import { Badge, type BadgeProps } from "@fluentui/react-components"
import type { NodeStatus } from "@rema/shared/schemas/common"
import { nodesI18n } from "./i18n"

// Badge de estado de nodo — docs/05 §4: active verde, draining ámbar, down rojo,
// disabled gris. Se usa el color semántico de Fluent (sin hex).
const COLOR_BY_STATUS: Record<NodeStatus, BadgeProps["color"]> = {
  active: "success",
  draining: "warning",
  down: "danger",
  disabled: "subtle",
}

export const NodeStatusBadge = ({ status }: { status: NodeStatus }) => (
  <Badge appearance="filled" color={COLOR_BY_STATUS[status]}>
    {nodesI18n.status[status]}
  </Badge>
)
